import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  openUpload: false,
  uploadProgress: 0,
  uploadErrorMessage: '',
  uploading: false,
  successfullyUploaded: false,
  formData: null
};

const rewardBulkUploadSlice = createSlice({
  name: 'rewardBulkUpload',
  initialState,
  reducers: {
    setOpenUpload: (state, action) => {
      state.openUpload = action.payload;
    },
    setUploadProgress: (state, action) => {
      state.uploadProgress = action.payload;
    },
    setUploadErrorMessage: (state, action) => {
      state.uploadErrorMessage = action.payload;
    },
    setUploading: (state, action) => {
      state.uploading = action.payload;
    },
    setSuccessfullyUploaded: (state, action) => {
      state.successfullyUploaded = action.payload;
    },
    setFormData: (state, action) => {
      state.formData = action.payload;
    },
    // Open upload modal
    openUploadModal: (state) => {
      state.openUpload = true;
    },
    // Close upload modal
    closeUploadModal: (state) => {
      state.openUpload = false;
    }
  }
});

export const {
  setOpenUpload,
  setUploadProgress,
  setUploadErrorMessage,
  setUploading,
  setSuccessfullyUploaded,
  setFormData,
  openUploadModal,
  closeUploadModal
} = rewardBulkUploadSlice.actions;

export default rewardBulkUploadSlice.reducer;

// Selectors for easy state access
export const selectRewardBulkUpload = (state) => state.rewardBulkUpload;
export const selectOpenUpload = (state) => state.rewardBulkUpload.openUpload;
export const selectUploadProgress = (state) =>
  state.rewardBulkUpload.uploadProgress;
export const selectUploadErrorMessage = (state) =>
  state.rewardBulkUpload.uploadErrorMessage;
export const selectUploading = (state) => state.rewardBulkUpload.uploading;
export const selectSuccessfullyUploaded = (state) =>
  state.rewardBulkUpload.successfullyUploaded;
export const selectFormData = (state) => state.rewardBulkUpload.formData;
